export const SocialLinks = {
  facebook: 'https://www.facebook.com/RomDomDom.school',
  instagram: 'https://www.instagram.com/romdomdom.school/',
  messages: 'https://www.facebook.com/messages/t/112310597191145',
  telegram: 'https://t.me/romdomdomua',
  viber: '/viber-link',
};
